<template>
	<div class="shitang13">
        
        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="tableData"
                stripe
                border>
                <el-table-column
                    prop="name"
                    label="菜单">
                </el-table-column>

                <el-table-column label="投票" >
                    <template slot-scope="scope">
                        <p style="color: red;">{{ scope.row.num }}</p>
                    </template>
                </el-table-column>

            </el-table>

        </el-card>    

    </div>
</template>

<script>
    import { url } from '../router/api';
	export default{
		data(){
			return{
                tableData: [],
            }
        },
        mounted() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: '加载中',
                background: 'rgba(0, 0, 0, 0.7)'
            });
           
            this.axios.get(url + 'complaint/searchSt3', {
                params:{
                   id:'',
                }
            }).then(res=> {
                loading.close();
                this.tableData = res.data.data
            }).catch(err=> {
                loading.close();
                console.log(err);
            });
        },
    }
</script>

<style scoped="scoped" lang='less'>
    .shitang13 {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .shitang13 .el-input {
        width:140px;
        margin-right: 20px;
    }
 
    .shitang13 .el-select {
        width:140px;
        margin-right: 20px;
    }
    .shitang13 main {
        margin-bottom: 20px;
    }
    .shitang13 .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>

